export const stripHash = (value) =>
  typeof value === 'string' ? value.replace('#', '').trim() : '';

export const addHash = (value) => {
  const raw = typeof value === 'string' ? value.trim() : '';
  if (!raw) return '';
  return raw.startsWith('#') ? raw : `#${raw}`;
};

export const isValidHexWithHash = (color) =>
  /^#[0-9A-Fa-f]{6}$/.test(String(color || ''));

export const normalizeHexWithHash = (color, fallback = '#64748B') => {
  const normalized = addHash(color);
  return isValidHexWithHash(normalized) ? normalized : fallback;
};

/** Pick readable text color for a background HEX. */
export const pickContrastingTextColor = (backgroundHex) => {
  const hex = normalizeHexWithHash(backgroundHex).replace('#', '');
  const r = parseInt(hex.slice(0, 2), 16);
  const g = parseInt(hex.slice(2, 4), 16);
  const b = parseInt(hex.slice(4, 6), 16);
  const luminance = 0.299 * r + 0.587 * g + 0.114 * b;
  return luminance > 170 ? '#111827' : '#FFFFFF';
};
